import { createContext, useContext } from "react";

export const CodeMirrorViewContext = createContext(null);

export function useCodeMirrorViewContext() {
    const context = useContext(CodeMirrorViewContext);
    if (!context) {
        throw new Error("useCodeMirrorViewContext must be used within CodeMirrorViewContext.Provider");
    }
    return context;
}
